<template>
  <div class="col">
    <div class="row">
      <b-button class="btn btn-success ml-2 mb-2" @click="newConstruction()">
        Criar uma nova Obra
      </b-button>
    </div>
    <div class="row">
      <Card
        v-for="construction in constructions"
        v-bind:key="construction.id"
        :name="construction.identifier_name"
        :imageURL="'https://via.placeholder.com/200x320'"
        :resourceId="construction.id"
        @clicked="editConstruction($event)"
      />
    </div>
  </div>
</template>

<script>
import { Stack, StackItem } from 'vue-stack-grid';
import { mapActions, mapGetters, mapState } from 'vuex';
import Card from '../../../components/Journal/Card.vue';
import makeToast from '../../../mixins/makeToast';

export default {
  name: 'journal',
  mixins: [makeToast],
  components: { Stack, StackItem, Card },
  data() {
    return {
      constructions: [],
    };
  },
  computed: {
    ...mapState(['token', 'dadosUsuario']),
    ...mapGetters('journal', ['setConstructions']),
  },
  created() {
    this.getConstructions(this.dadosUsuario.id)
      .then((response) => {
        console.log(response);
        this.constructions = response.data.data;
      })
      .catch((error) => {
        console.log(error);
        this.makeToast(
          'Oopss!',
          'Não foi possivel carregar as construções!',
          'danger'
        );
      });
  },
  methods: {
    ...mapActions('journal', ['getConstructions', 'createNewConstruction']),
    newConstruction() {
      this.createNewConstruction({
        userId: this.dadosUsuario.id,
        data: {
          identifier_name: 'Nova Obra',
        },
      })
        .then((response) => {
          console.log(response);

          this.makeToast('Sucesso!', 'Você criou uma nova Obra!', 'success');

          setTimeout(() => {
            this.editConstruction(response.data.data.id);
          }, 1000);
        })
        .catch((error) => {
          console.log(error);
          this.makeToast(
            'Oopss!',
            'Não foi possivel carregar as construções!',
            'danger'
          );
        });
    },
    editConstruction(id) {
      this.$router.push({
        name: 'journal-view-edit-construction',
        params: { id },
      });
    },
  },
};
</script>

<style scoped>
.border-radius {
  border-radius: 8px;
}

.no-text-decoration:hover {
  color: var(--orange-primary);
  text-decoration: none;
}

.table td,
.table th {
  vertical-align: middle;
}
</style>
